import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { BaseMachine } from "abreact/incubator/ui/machine/BaseMachine";
import { NestedError } from "abweb/dto/exception/NestedError";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { ErrorContext } from "abweb/utils/error/ErrorContext";
import { computed, observable, makeObservable } from "mobx";
export let StandardErrorRendererMachine = (_class = class StandardErrorRendererMachine extends BaseMachine {
  constructor(error) {
    super();
    _initializerDefineProperty(this, "_error", _descriptor, this);
    makeObservable(this);
    if (ClassUtils.isInstanceOf(error, Error)) {
      this._error = error;
    } else if (ClassUtils.isInstanceOf(error, ErrorContext)) {
      this._error = error.error;
    } else {
      this._error = new Error(error.message ?? error.toString());
    }
  }
  get title() {
    if (this._error.name) {
      return this._error.name === 'Error' ? 'Unexpected Error' : this._error.name;
    }
    return AbWebResources.fallbackErrorTitle();
  }
  get message() {
    return this._error.message;
  }
  get stackTrace() {
    if (this._error.stack) {
      return this._error.stack;
    }
    return null;
  }
  get causedBy() {
    if (ClassUtils.isInstanceOf(this._error, NestedError)) {
      return this._error.causedBy;
    }
    return null;
  }
  get showCausedBy() {
    return true;
  }
  getSupportDetailsText() {
    return null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "message", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "message"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stackTrace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "stackTrace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "causedBy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "causedBy"), _class.prototype), _class);
//# sourceMappingURL=StandardErrorRendererMachine.js.map
